export const Settings = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
    <path d="M446-109v-248h86v81h317v86H532v81h-86Zm-336-81v-86h256v86H110Zm170-166v-81H110v-86h170v-81h86v248h-86Zm166-81v-86h403v86H446Zm147-166v-248h86v81h170v86H679v81h-86Zm-483-81v-86h403v86H110Z" />
  </svg>
);
